import axios from 'axios';
import httpRequest from 'services/httpRequest';

export const fetchTodo = async (url: string, token?: string | null) => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return axios.get(url, {
    headers,
  });
};
export const postTodo = async (url: string, data: any, token?: string | null) => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return axios.post(url, data, {
    headers,
  });
};
export const putTodo = (url: string, data: any, token?: string | null) => {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  return axios.request({
    url,
    method: "PUT",
    data,
    headers,
  });
};

export const fetchMultiRequest = async (url: string) => {
  return httpRequest.get(url);
};

export const deleteTodo = async (url: string, token?: string | null) => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return axios.delete(url, {
    headers,
  });
};
